import React from 'react';
import { clsx } from 'clsx';

import { HeaderActionBtn } from '@/components/common/profile/DetailsSection/components/DetailsSectionHeader';

import s from './EditButton.module.scss';

interface Props {
  onClick: () => void;
  incomplete?: boolean;
}

export const EditButton = (props: Props) => {
  const { onClick, incomplete } = props;

  return (
    <HeaderActionBtn
      onClick={onClick}
      className={clsx(s.root, s.edit, {
        [s.incomplete]: incomplete,
      })}
    >
      <EditIcon /> Edit
    </HeaderActionBtn>
  );
};

const EditIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ transform: 'translateY(-1px)' }}
  >
    <path
      d="M12.8789 1.35156L13.3984 1.87109C14 2.47266 14 3.42969 13.3984 4.03125L12.5781 4.85156L9.89844 2.17188L10.7188 1.35156C11.3203 0.75 12.2773 0.75 12.8789 1.35156ZM4.70312 7.36719L9.26953 2.80078L11.9492 5.48047L7.38281 10.0469C7.21875 10.2109 7 10.3477 6.78125 10.4297L4.34766 11.2227C4.12891 11.3047 3.85547 11.25 3.69141 11.0586C3.5 10.8945 3.44531 10.6211 3.52734 10.4023L4.32031 7.96875C4.40234 7.75 4.53906 7.53125 4.70312 7.36719ZM2.625 2.5H5.25C5.71484 2.5 6.125 2.91016 6.125 3.375C6.125 3.86719 5.71484 4.25 5.25 4.25H2.625C2.13281 4.25 1.75 4.66016 1.75 5.125V12.125C1.75 12.6172 2.13281 13 2.625 13H9.625C10.0898 13 10.5 12.6172 10.5 12.125V9.5C10.5 9.03516 10.8828 8.625 11.375 8.625C11.8398 8.625 12.25 9.03516 12.25 9.5V12.125C12.25 13.5742 11.0742 14.75 9.625 14.75H2.625C1.17578 14.75 0 13.5742 0 12.125V5.125C0 3.67578 1.17578 2.5 2.625 2.5Z"
      fill="currentColor"
    />
  </svg>
);
